import React from "react";
import styles from "./detalle.module.css";

const Detalle = ({ data }) => {
    return (
        <div className={styles.container}>
            <div className={styles.nombres}>
                {data.nombres}
            </div>

            <div className={styles.mensaje}>
                Excelente, de la siguiente manera podrás realizar el primer pago a través de Safetypay 
                y continuar con la evaluación de tu solicitud {data.numeroSolicitud}
            </div>

            <div className={styles.cards}>
                <div className={styles.codigo_pago}>
                    <div className={styles.card_header}>
                        Código de pago
                    </div>
                    <div className={styles.card_body}>
                        {data.codigo}
                    </div>
                </div>
                <div className={styles.monto_pago}>
                    <div className={styles.card_header}>
                        Monto total a pagar
                    </div>
                    <div className={styles.card_body}>
                        {data.monto}
                    </div>
                </div>
                <div className={styles.fecha_pago}>
                    <div className={styles.card_header}>
                        La transacción expira
                    </div>
                    <div className={styles.card_body}>
                        {data.fechaVencimiento}
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Detalle;